import { gsap } from 'gsap'
import Component from '../lib/Component'
import { removeClass } from '../lib/Utils'
import { hasClass } from '../lib/Utils'
import { addClass } from '../lib/Utils'

export default class Accordions extends Component {
    static selector = '.js-accordion'

    initialize() {
        this.holder = this.$el

        let _defaults = {
            openingEase: 'power3.out',
            closingEase: 'power2.out',
            openDuration: 0.5,
            closeDuration: 0.3,
            openDelay: 0,
            closeDelay: 0,
            onOpenStart: () => {},
            onCloseStart: () => {},
            onOpenComplete: () => {},
            onCloseComplete: () => {},
        }

        this.openingEase = 'power3.out'
        this.closingEase = 'power2.out'
        this.openDuration = 0.5
        this.closeDuration = 0.3
        this.openDelay = 0
        this.closeDelay = 0
        this.onOpenStart = () => {}
        this.onCloseStart = () => {}
        this.onOpenComplete = () => {}
        this.onCloseComplete = () => {}

        const mono = this.holder.classList.contains('is-mono')
        this.initAccordion(this.holder, mono)
    }

    initAccordion(accordion, mono) {
        if (accordion.classList.contains('is-initialed')) return

        accordion.classList.add('is-initialed')

        const accordionSingles =
            accordion.querySelectorAll('.js-accordion-item')

        accordionSingles.forEach((accordionSingle) => {
            this.accordionController(accordionSingle, accordion, mono)
        })
    }

    accordionController(accordionSingle, accordion, mono) {
        let accordionHeader = accordionSingle.querySelector(
            '.js-accordion-header',
        )

        if (accordionHeader == null) {
            accordionHeader = accordionSingle
        }

        if (accordionHeader == null) {
            throw new Error("'js-accordion-header' missing!")
        }

        const accordionContent = accordionSingle.querySelector(
            '.js-accordion-panel',
        )

        if (accordionContent == null) {
            throw new Error("'js-accordion-panel' missing!")
        }

        if (!accordionHeader.classList.contains('is-opened')) {
            gsap.set(accordionContent, {
                height: 0,
            })
        }

        accordionHeader.addEventListener('click', (ev) => {
            ev.preventDefault()

            if (ev.currentTarget.classList.contains('is-opened')) {
                this.closeAccordion(
                    ev.currentTarget,
                    accordionContent,
                    accordion,
                )
                return
            }

            this.openAccordion(
                ev.currentTarget,
                accordionContent,
                accordion,
                mono,
            )
        })
    }

    closeAccordion(accordionHeader, accordionContent, accordion) {
        accordionHeader.classList.remove('is-opened')

        gsap.fromTo(
            accordionContent,
            {
                height: accordionContent.offsetHeight,
            },
            {
                duration: this.closeDuration,
                height: 0,
                delay: this.closeDelay,
                ease: this.closingEase,
                onStart: () => {
                    this.onCloseStart(accordionHeader, accordionContent)
                },
                onComplete: () => {
                    this.onCloseComplete(accordionHeader, accordionContent)
                },
            },
        )

        if (
            accordionHeader.parentNode.classList.contains('js-accordion-item')
        ) {
            accordionHeader.parentNode.classList.remove('is-opened')
        }

        this.haveActive(accordion)
    }

    openAccordion(accordionHeader, accordionContent, accordion, mono) {
        if (mono) {
            const accordionSingles =
                accordion.querySelectorAll('.js-accordion-item')

            for (let i = 0; i < accordionSingles.length; i++) {
                const accordionHeaderInactive = accordionSingles[
                    i
                ].querySelector('.js-accordion-header')
                const accordionContentInactive = accordionSingles[
                    i
                ].querySelector('.js-accordion-panel')

                if (accordionHeader === accordionHeaderInactive) {
                    continue
                }

                accordionHeaderInactive.classList.remove('is-opened')
                if (
                    accordionHeader.parentNode.classList.contains(
                        'js-accordion-item',
                    )
                ) {
                    accordionHeaderInactive.parentNode.classList.remove(
                        'is-opened',
                    )
                }

                if (accordionContentInactive.style?.height !== '0px') {
                    gsap.to(accordionContentInactive, {
                        duration: this.closeDuration,
                        height: 0,
                        delay: this.closeDelay,
                        ease: this.closingEase,
                        onStart: () => {
                            this.onCloseStart(accordionHeader, accordionContent)
                        },
                        onComplete: () => {
                            this.haveActive(accordion)
                            this.onCloseComplete(
                                accordionHeader,
                                accordionContent,
                            )
                        },
                    })
                }
            }
        }

        accordionHeader.classList.add('is-opened')
        if (
            accordionHeader.parentNode.classList.contains('js-accordion-item')
        ) {
            accordionHeader.parentNode.classList.add('is-opened')
        }
        let height = 0

        gsap.set(accordionContent, {
            height: 'auto',
            onComplete: () => {
                height = accordionContent.clientHeight

                gsap.set(accordionContent, {
                    height: 0,
                    onComplete: () => {
                        gsap.to(accordionContent, {
                            duration: this.openDuration,
                            height: height,
                            ease: this.openingEase,
                            delay: this.openDelay,
                            onStart: () => {
                                this.onOpenStart(
                                    accordionHeader,
                                    accordionContent,
                                )
                            },
                            onComplete: () => {
                                accordionContent.style.height = 'auto'
                                this.onOpenComplete(
                                    accordionHeader,
                                    accordionContent,
                                )
                            },
                        })
                    },
                })
            },
        })
    }

    haveActive(accordion) {
        if (accordion.querySelectorAll('.is-opened').length > 0) {
            addClass(accordion, 'have-active')
        } else {
            removeClass(accordion, 'have-active')
        }
    }
}
